/**
 * KatalogSearchPanelContent — thin wrapper around canonical FeedSearchPanelContent.
 */
import * as React from 'react';
import { CheckCircle, Pause, Archive } from 'lucide-react';
import {
  FeedSearchPanelContent,
  type FeedSectionShortcut,
} from '@bright-web-skeleton/ui';
import type { KatalogSectionKey } from './KatalogShortcutRail';

export interface KatalogSearchPanelContentProps {
  searchQuery: string;
  onSearchQueryChange: (q: string) => void;
  onExecuteSearch: (explicitQuery?: string) => void;
  activeSections: KatalogSectionKey[];
  onToggleSection: (section: KatalogSectionKey) => void;
}

const SECTION_SHORTCUTS: FeedSectionShortcut<KatalogSectionKey>[] = [
  { key: 'active', label: 'Active', icon: CheckCircle },
  { key: 'paused', label: 'Paused', icon: Pause },
  { key: 'ended', label: 'Ended', icon: Archive },
];

export const KatalogSearchPanelContent: React.FC<KatalogSearchPanelContentProps> = (props) => (
  <FeedSearchPanelContent<KatalogSectionKey>
    {...props}
    sectionShortcuts={SECTION_SHORTCUTS}
    recentSearchesKey="kloutforce-katalog"
    placeholder="Search your katalog..."
  />
);

export default KatalogSearchPanelContent;